import React from 'react';
import { View, StyleSheet } from 'react-native';
import { TagLabel } from '../../TagLabel';

export const LoyaltyChallengeBadge = (props: LoyaltyChallengeBadgeProps) => (
  <View style={styles.wrapper}>
    <TagLabel size="small" palette="primary">
      {props.label}
    </TagLabel>
  </View>
);

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  wrapper: {
    position: 'absolute',
    top: 0,
    left: 0,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type LoyaltyChallengeBadgeProps = {
  readonly label: string;
};
